<template>
	<div>
		<v-dialog v-model="dialog_text" persistent no-click-animation transition="slide-y-transition" max-width="290">
	      <v-card>
	      	<v-card-title class="title noshadow">{{ title }}</v-card-title>
	        <v-card-text>
                <v-textarea
                    label="Enter Text"
                    placeholder=" "
                    v-model="content"
                ></v-textarea>
            </v-card-text>
	        <v-divider></v-divider>
	        <!-- Data has been saved as draft. What would you like to do? -->
	        <v-card-actions style="padding:6px 0px;" center-align>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="fn_save">Save</v-btn>
                <v-btn color="primary" flat @click="fn_closeDialog">Cancel</v-btn>
		    </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['title', 'type', 'textContent'],
	data(){	
		return{
			dialog_text: false,
            content:null
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.dialog_text = true;
            this.content = this.textContent;
		},
		closeDialogWeb: function () {
			this.dialog_text = false;
		},
		fn_closeDialog: function(){
			if(this.$parent.fn_closeDialog){
				this.$parent.fn_closeDialog();
			}
			else{
				this.closeDialogWeb();
			}
		},
		fn_save: function(){
			// if(this.type=='yousaved'){
                // this.$set(this.$parent.TransactionSettings, 'thermalSavingText', this.content);
                // this.$parent.TransactionSettings.thermalSavingText = this.content;
            // }
            this.$parent.fn_saveText(this.content);
            // this.$forceUpdate();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_text.vue